import { GlobalAxios } from "../axios/axios-config";
import {
  INewTicketAutoTransferRule,
  ITicketAutoTransferRule,
} from "../models/ticket-auto-transfer-rule";

const TICKET_AUTO_FINISH_RULES_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketAutoTransferRule";

export const createTicketAutoTransferRule = (
  item: INewTicketAutoTransferRule
) => {
  return GlobalAxios.post(TICKET_AUTO_FINISH_RULES_ROUTE, item);
};

export const getTicketAutoTransferRuleById = (id: string) => {
  return GlobalAxios.get<ITicketAutoTransferRule>(
    TICKET_AUTO_FINISH_RULES_ROUTE + "/" + id
  );
};

export const updateTicketAutoTransferRuleById = ({
  item,
  id,
}: {
  item: INewTicketAutoTransferRule;
  id: string;
}) => {
  return GlobalAxios.put(TICKET_AUTO_FINISH_RULES_ROUTE + "/" + id, item);
};
